export default __webpack_public_path__ + "static/media/garlic.977aa833.png";